import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { LandQueueResponse } from '#models';

@Injectable({
  providedIn: 'root',
})
export class LandApiService {
  private _http = inject(HttpClient);
  private readonly _baseUrl = environment.apiUrl;

  getQueue(): Observable<LandQueueResponse> {
    return this._http.get<LandQueueResponse>(`${this._baseUrl}/land/queue`);
  }
}
